define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		ApproveControllers: {
			"ApparelBOMRevision": "Specification/BOM/ApproveBOM",
			"MaterialBOMRevision": "Specification/BOM/ApproveBOM"
		},

		getActionController: function(/*Context*/ctx, /*Action*/action) {
			// summary: return special action controller based on context
			var	id = action.m_id;
			if ((id == "Approve") || (id == "EndPhase")) {
				var	type = ctx.getNode().$Type;
				var	s = this.ApproveControllers[type];
				if (s) return s;
			}

			return this.inherited(arguments);
		}
	});
});